// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hGY5","index":"styles_index__2Mkk5"};